import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// Pages
import CartPage from "../pages/CartPage";
import TuckerStore from "../pages/LandingPage";
import AuthPage from "../pages/AuthPage";
import ChangePassword from "../pages/ChangePasswordPage";
import MyOrders from "../pages/MyOrdersPage";
import OrderConfirmationPage from "../pages/OrderSuccessPage";
import ProfilePage from "../pages/ProfilePage";
import OrderDetails from "../pages/OrderDetailsPage";
import TrackOrder from "../pages/TrackOrderPage";
import InvoicePage from "../pages/InvoicePage";
import WishlistPage from "../pages/WishlistPage";
import TermsAndConditions from "../pages/TermsAndConditions";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import WarrantyPolicy from "../pages/WarrantyPolicy";
import RefundPolicy from "../pages/RefundPolicy";
import ContactUs from "../pages/ContactUs";
import AboutUs from "../pages/AboutUs";
import ProductDetailsView from "../pages/ProductDetailsView";
import GoogleTag from "../components/GoogleTag";
// IdleTimer component for auto logout
import IdleTimer from "../components/IdleTimer";
import NotFound from "../pages/NotFoundPage";
import PromoStrip from "../components/PromoStrip";

const AppRoutes = () => (
  <BrowserRouter>
    <GoogleTag />

    {/* IdleTimer is now inside Router */}
    <IdleTimer timeout={3600000} />
    <Routes>
      <Route path="/" element={<TuckerStore />} />
      <Route
        path="/category/:category"
        element={
          <>
            <PromoStrip />
            <TuckerStore />
          </>
        }
      />
      <Route path="/changepassword" element={<ChangePassword />} />
      <Route path="/myorders" element={<MyOrders />} />
      <Route path="/wishlist" element={<WishlistPage />} />
      <Route
        path="/product-details/:productName/:productId"
        element={<ProductDetailsView />}
      />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/order-success" element={<OrderConfirmationPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/order-details/:orderId" element={<OrderDetails />} />
      <Route path="/track-order/:orderId" element={<TrackOrder />} />
      <Route path="/invoice/:razorpayOrderId" element={<InvoicePage />} />
      <Route path="/terms-conditions" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/warranty-policy" element={<WarrantyPolicy />} />
      <Route path="/return-policy" element={<RefundPolicy />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/aboutus" element={<AboutUs />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default AppRoutes;
